import { render, staticRenderFns } from "./tjbgList.vue?vue&type=template&id=44d3dbe5&scoped=true&"
import script from "./tjbgList.vue?vue&type=script&lang=js&"
export * from "./tjbgList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/css.css?vue&type=style&index=0&id=44d3dbe5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d3dbe5",
  null
  
)

export default component.exports